export const TYPES = ['shipping', 'billing'];

export const FIELDS = [
    ['[firstname]', 'firstName'],
    ['[lastname]', 'lastName'],
    ['[email]', 'email'],
    ['[street][]', 'address'],
    ['[street][]', 'other'],
    ['[city]', 'city'],
    ['[region_id]', 'regionID'],
    ['[region]', 'state'],
    ['[postcode]', 'postal'],
    ['[country_id]', 'country'],
    ['[telephone]', 'phone'],
    ['[address_id]', 'addressID'],
] as const;
